export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK.be74916c.png";